import {type PartialOptions, UI} from "../../../../../stem-core/ui/UIBase";
import {StyleSheet} from "../../../../../stem-core/ui/Style";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/decorators/Style";
import {DateRangeHeader} from "./sections/DateRangeHeader";
import {DateRangeCalendarInput} from "./sections/DateRangeCalendarInput";
import {DashboardBaseInput} from "../../../../../core/ui/input/BaseInput.js";
import type {StemDate} from "../../../../../stem-core/time/Date";
import type {UIElement} from "../../../../../stem-core/ui/UIBase";
import type {NodeAttributes} from "../../../../../stem-core/ui/NodeAttributes";
import type {DateRangeValue} from "../DateRangePickerConstants";


class DateRangePickerStyle extends StyleSheet {
    @styleRule
    header = {
        padding: "14px 24px 18px",
    };

    @styleRule
    calendar = {
        padding: 24,
        background: this.themeProps.WHITE,
    };

    @styleRule
    dateRangePickerElement = {
        userSelect: "none",
    }
}

interface DateRangePickerInputOptions {
    minDate?: StemDate;
    maxDate?: StemDate;
    dispatchTarget?: UIElement;
}

@registerStyle(DateRangePickerStyle)
export class DateRangePickerInput extends DashboardBaseInput<DateRangePickerInputOptions> {
    declare header: DateRangeHeader;

    getDefaultOptions(): PartialOptions<DateRangePickerInput> {
        return {
            ...super.getDefaultOptions(),
            minDate: null,
            maxDate: null,
        }
    }

    isEqual(valueA: DateRangeValue, valueB: DateRangeValue) {
        return valueA.startDate === valueB.startDate &&
            valueA.endDate === valueB.endDate &&
            valueA.currentPick === valueB.currentPick;
    }

    extraNodeAttributes(attr: NodeAttributes) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.dateRangePickerElement);
    }

    render() {
        const {styleSheet} = this;
        // TODO what is the dispatchTarget? probably delete it
        const {minDate, maxDate, dispatchTarget} = this.options;
        const options = {
            initialValue: this.value,
            onChange: (value: DateRangeValue) => {
                // TODO @cleanup currentPick smells
                const {currentPick} = value;
                if (currentPick === 0) {
                    this.setAndDispatchValue(value);
                } else {
                    this.setValue(value);
                }
            },
            minDate, maxDate, dispatchTarget
        };

        return [
            <DateRangeHeader {...options} className={styleSheet.header} ref="header"/>,
            <DateRangeCalendarInput {...options} className={styleSheet.calendar}/>
        ]
    }

    onMount() {
        super.onMount();
        this.header.addListener("pickUpdate", (currentPick: number) => {
            this.setValue({...this.value, currentPick});
        })
    }
}
